import { createFileRoute } from '@tanstack/react-router'
import { redirectToFirstUnit } from '@/features/accommodation/redirectToFirstUnit'

// Legacy URL — detail pages moved from /ubytovani/<slug>/detail under the
// unit, see redirectToFirstUnit. The query string has to survive the redirect:
// old TikTok and newsletter links still point here with their utm parameters.
export const Route = createFileRoute('/ubytovani/$slug/detail')({
  beforeLoad: ({ context, params, location }) =>
    redirectToFirstUnit(context.queryClient, params.slug, '', location.searchStr),
})
